import { render, staticRenderFns } from "./MD.vue?vue&type=template&id=8f79b0a8"
import script from "./MD.vue?vue&type=script&lang=js"
export * from "./MD.vue?vue&type=script&lang=js"
import style0 from "./MD.vue?vue&type=style&index=0&id=8f79b0a8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports